"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const get_1 = __importDefault(require("lodash/get"));
const styles = {
    container: {
        padding: '0.4rem',
        display: 'flex',
        flexDirection: 'column',
    },
    text: {
        color: '#fd000c',
        margin: '0.5px',
        fontSize: '0.9em',
    },
};
function FormikError({ style, name, children }) {
    const { errors, isValid, dirty, touched } = (0, formik_1.useFormikContext)();
    const errorText = (0, get_1.default)(errors, name);
    const isTouched = (0, get_1.default)(touched, name);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { ...styles.container, ...style?.container }, children: [children, !isValid && dirty && isTouched && ((0, jsx_runtime_1.jsx)("span", { style: { ...styles.text, ...style?.text }, children: errorText }))] }));
}
exports.default = FormikError;
